import axios from '../utils/axios';

export default function downloadCompetitionData(adminId, params) {
    
    return (
        axios.get('/admin/'+adminId + '/competition/v2/competition/admin/listing/download', { params, responseType: 'blob' })
    )
}
